export default "__VITE_ASSET__CZ5fM0x6__"